import React, { useEffect, useState, useMemo } from "react";
import "./Template_new.css";
import Header from "../../components/Header/header";
import Footer from "../../components/Footer/Footer";
import { Col, Form, Row } from "react-bootstrap";
import HdrTemplateNew from "./HDRTemplateNew/HdrTemplateNew";
import DtlTemplateNew from "./DTLTemplateNew/DtlTemplateNew";
import WesTemplateNew1 from "./WESTemplateNew/WesTemplateNew1";
import WesTemplateNew2 from "./WESTemplateNew/WesTemplateNew2";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { confirmToast } from "../../components/ConfirmToast/ConfirmToast";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { SpaceBarTwoTone } from "@mui/icons-material";

const TemplatesNew = () => {
  const authToken = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const { soldTo, division, planYear } = useParams();
  const cleanedCustomerID = soldTo?.replace(/_copy$/i, "");
  const isCopy = /_copy$/i.test(soldTo);
  const location = useLocation();
  const [SingleApiData, setSingleApiData] = useState({});
  // console.log("SingleApiData",SingleApiData)
  const Hdrvalu = SingleApiData?.hdr;
  const WesValue = SingleApiData?.wes;
  const DTLValue = SingleApiData?.dtl;
  const WesNewValue = SingleApiData?.partP;
  const [selectedYear, setSelectedYear] = useState(planYear || "");
  const [availableYears, setAvailableYears] = useState([]);
  const [selectedHandler, setSelectedHandler] = useState(division || "");
  const [availableHandler, setAvailableHandler] = useState([]);
  const [secondApiData, setSecondApiData] = useState([]);
  const [allUniqueSoldTos, setAllUniqueSoldTos] = useState([]);
  const [hdrData, setHdrData] = useState({});
  const [dtlData, setDtlData] = useState(null);
  const [timeScreen, setTimeScreen] = useState("");
  const [wesData, setWesData] = useState({});
  const [wes2Data, setWes2Data] = useState({});
  const [sumbitLoading, setSubmitLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [isRequired, setIsRequired] = useState(false);


  const [detailDiv, setDetailDiv] = useState({
    companyId: "",
    planYear: "",
    planMonth: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ],
    division: "",
    distributor: "",
    area: "",
    vtrGroup: "",
    soldTo: "",
    deliveryId: "",
    umsatzAnteile: Array(12).fill(""),
    abschriftenAnteilePct: Array(12).fill(""),
    kollVoorderPct: Array(12).fill(""),
    nosVororderPct: Array(12).fill(""),
    nosNachorderPct: Array(12).fill(""),
  });

  // console.log('dtl data?', dtlData)


  const [templateWesNewPart, setTemplateWesNewPart] = useState({
    koll: [
      {
        soldTo: hdrData.soldTo,
        planYear: hdrData.planYear,
        division: hdrData.division,
        typId: "KOLL",
        percValue: "",           // kollektion %
        partAmount: null,
        delivQuota: "",          // koll  auslief quote
        prePerc: "",             //  koll vororder %
        preAmount: null,
        reAmount: "",
        estimatedCalc: "",       // koll Eingang Aufschlag
        estimatedCalcDisc: "",   // koll Eingang Abschlag
        outgoingCalc: "",       // koll Nach Aufschlag
        outgoingCalcDisc: "",   // koll Nach Abschlag
        percred: "",           // koll Abschrift prozentual 
        lugPlan: "",            // Koll Lug 
        planStockAvail: null,
        rePerct: ""
      }
    ],

    Nos: [
      {
        soldTo: hdrData.soldTo,
        planYear: hdrData.planYear,
        division: hdrData.division,
        typId: "NOS",
        percValue: "",               // NOS %
        partAmount: null,
        delivQuota: "",              // NOS  auslief quote
        prePerc: "",                 //  NOS vororder %
        preAmount: null,
        reAmount: "",
        estimatedCalc: "",           // NOS Eingang Aufschlag
        estimatedCalcDisc: "",       // NOS Eingang Abschlag
        outgoingCalc: "",              // NOS Nach Aufschlag
        outgoingCalcDisc: "",          // NOS Nach Abschlag
        percred: "",                  // NOS Abschrift prozentual 
        lugPlan: "",                   // NOS Lug 
        planStockAvail: null,
        rePerct: ""
      }
    ]
  })

  // console.log("templateWesNewPart",templateWesNewPart)

  const isEmpty = (value) => {
    return value === undefined || value === null || String(value).trim() === "";
  };
  const showSubmit =
    location.pathname === "/newScreen-template" ||
    location.pathname.includes("_copy");
  // console.log("showSubmit",showSubmit)
  const [resetFlag, setResetFlag] = useState(false);
  const [resetText, setResetText] = useState(false);

  //  console.log("resetFlag", resetFlag);
  // console.log("resetText", resetText);

  // read reducx Data
  const templateDetails = useSelector(
    (state) => state.template.templateDetails
  );

  // console.log(
  //   "Redux template data:",
  //   templateDetails?.some((items) => {
  //     console.log(items.planYear)
  //   })
  // );


  const isPayloadChanged = (oldData, newData) => {
    return JSON.stringify(oldData) !== JSON.stringify(newData);
  };


  useEffect(() => {
    dropDownFunction(); // second API is triggered from inside this
  }, []);

  const dropDownFunction = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_LINK}/api/v1/admin/dropDownArraysForCustomerSummary`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data;
      // console.log("data?>>", data)

      if (Array.isArray(data.years) && data.years.length > 0) {
        setAvailableYears(data.years.slice().reverse());
      }

      if (Array.isArray(data.divs) && data.divs.length > 0) {
        setAvailableHandler(data.divs);
      }
    } catch (error) {
      console.error("Dropdown API error:", error);
    }
  };

  const goesValueDopDown = async (year, div) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_LINK}/api/v1/entry/getSoldToByYearAndDiv?div=${div}&year=${year}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      // console.log("response", response)
      const allData = response.data;
      // console.log("allData", allData)
      setSecondApiData(allData);
      const soldTos = allData.map((data) => data.soldTo);
      // console.log("soldTos", soldTos)
      setAllUniqueSoldTos(soldTos)
      // if (Array.isArray(data) && data.length === 0) {
      //   setSecondApiData([]);
      //   // console.log("empty Array!");
      // }
    } catch (error) {
      console.error("Second API error:", error);
    }
  };

  useEffect(() => {
    if (selectedYear !== "" && selectedHandler !== "") {
      goesValueDopDown(selectedYear, selectedHandler);
    } else {
      setSecondApiData([]);
      setAllUniqueSoldTos([])
    }
  }, [selectedYear, selectedHandler]);


  const getFunction = (e) => {
    const { name, value } = e.target;
    if (name === "jahrDropdown") {
      setSelectedYear(value);
    } else if (name === "divDropdown") {
      setSelectedHandler(value);
    }
  };

  const handleHdrDataChange = (updatedData) => {
    // console.log("updatedData>>>>>>", updatedData)
    setHdrData(updatedData);
    setResetFlag(false);
  };
  const handleDtlDataChange = (updatedDtl) => {
    setDtlData(updatedDtl);
    setResetFlag(false);
  };
  const handleWesDataChange = (data) => {
    // console.log("data checking", data)
    setWesData(data);
    setResetFlag(false);
  };
  const handleWes2DataChange = (data) => {
    setWes2Data(data)
    setResetFlag(false);
  }

  const showToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 3000,
    });
  };

  // back btn code
  const getBack = () => {
    navigate("/template");
  };

  const getReset = async () => {
    const confirm = await confirmToast(
      "Are you sure you want to reset all the fields?"
    );

    if (!confirm) return;

    setSingleApiData({});
    setTimeScreen("");
    setSelectedYear("");
    setSelectedHandler("");

    setResetFlag(true);

    // setTimeout(() => {
    //   setResetFlag(false);
    // }, 0);
  };


  // Submit api function 

  const getSubmitData = async () => {
    const { description, soldTo } = hdrData;


    // reset value description and customerId 
    if (!resetText) {
      setResetText(true);
      // console.log("resetText just set to TRUE");
      return;
    }


    // Manual validation

    if (!description?.trim()) {
      showToast("Description field is required");
      return;
    }

    if (!soldTo?.trim()) {
      showToast("Please select a Kd Number");
      return;
    }

    // Manual validation for dtlData
    if (!detailDiv || !Array.isArray(detailDiv.umsatzAnteile)) {
      showToast("Detail data is missing");
      return;
    }
    // console.log('dtl data?', dtlData)
    const len = detailDiv.umsatzAnteile.length;
    // for (let i = 0; i < len; i++) {
    //   if (
    //     isEmpty(dtlData.umsatzAnteile[i]) ||
    //     isEmpty(dtlData.abschriftenAnteilePct[i]) ||
    //     isEmpty(dtlData.kollVoorderPct[i]) ||
    //     isEmpty(dtlData.nosVororderPct[i]) ||
    //     isEmpty(dtlData.nosNachorderPct[i])
    //   ) {
    //     showToast(`Please fill in all the input fields in the table.`);
    //     return; // stop submit
    //   }
    // }

    setSubmitLoading(false);
  };


  const handleDelete = async () => {
    const { soldTo, division, planYear } = hdrData;
    // console.log("hdr Data", soldTo, division, planYear)
    const isConfirmed = await confirmToast(
      `Are you sure want to delete ${soldTo} template?`
    );
    if (!isConfirmed) return;

    // ✅ CHECK IN REDUX ARRAY (customerId + division + year)
    const isTemplateExist = templateDetails?.some((item) => {
      return (
        item.soldTo === soldTo &&
        item.division === division &&
        item.planYear === planYear
      );
    });
    // console.log('template details?', isTemplateExist)
    // return;

    // ❌ If not exist → show error
    if (!isTemplateExist) {
      toast.error("This template is not created. Please create it first.");
      return;
    }

    setDeleteLoading(true);

    const api = `${process.env.REACT_APP_API_LINK}/api/v1/entry/deleteTemplateBySoldTo?soldTo=${soldTo}&division=${division}&planYear=${planYear}`;

    try {
      const res = await axios.delete(api, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      toast.success(res.data.message);
      navigate("/template");
    } catch (error) {
      toast.error(`${soldTo} - Delete failed.`);
      console.error("Delete failed:", error);
    } finally {
      setDeleteLoading(false);
    }
  };

  // formated data array of object only dtl allows 
  const formattedDTLData = detailDiv?.planMonth.map((month, index) => ({
    planMonth: month,

    umsatzAnteile:
      parseFloat(
        String(detailDiv.umsatzAnteile[index]).replace(",", ".")
      ) || 0,

    abschriftenAnteilePct:
      parseFloat(
        String(detailDiv.abschriftenAnteilePct[index]).replace(",", ".")
      ) || 0,

    kollVoorderPct:
      parseFloat(
        String(detailDiv.kollVoorderPct[index]).replace(",", ".")
      ) || 0,

    nosVororderPct:
      parseFloat(
        String(detailDiv.nosVororderPct[index]).replace(",", ".")
      ) || 0,

    nosNachorderPct:
      parseFloat(
        String(detailDiv.nosNachorderPct[index]).replace(",", ".")
      ) || 0,

    companyId: hdrData.companyId,
    planYear: selectedYear,
    division: selectedHandler,
    distributor: hdrData.distributor,
    area: hdrData.area,
    vtrGroup: hdrData.vtrGroup,
    soldTo: hdrData.soldTo,
  }));

  const handleUpdate = async () => {
    const { description, soldTo, division, planYear } = hdrData;
    // console.log('hdrdata?', hdrData);
    // console.log('wesdata?', wesData)
    // console.log('wesdata 2?', wes2Data)
    // console.log('dtl data?', dtlData)
    const {
      umsatzAnteile = [],
      abschriftenAnteilePct = [],
      kollVoorderPct = [],
      nosNachorderPct = [],
      nosVororderPct = [],
    } = detailDiv || {};

    const { koll = [], Nos = [] } = templateWesNewPart || {};


    // ✅ Basic validations
    if (!description?.trim()) {
      showToast("Description field is required");
      return;
    }
    else if (!soldTo?.trim()) {
      showToast("Please select a Kd Number");
      return;
    }
    else if (!koll[0] || !Nos[0]) {
      showToast("Please provide Koll and Nos percentage value");
      return;
    } else if (koll[0]?.prePerc !== 100) {
      showToast("Koll VorOrder percentage must be 100");
      return;
    } else if (!Nos[0]?.prePerc && !Nos[0]?.rePerct) {
      showToast("Please provide Nos percentage value");
      return;
    }
    else if (!detailDiv || !Array.isArray(detailDiv.umsatzAnteile)) {
      showToast("Detail data is missing");
      return;
    }

    const len = detailDiv.umsatzAnteile.length;
    // for (let i = 0; i < len; i++) {
    //   if (
    //     isEmpty(dtlData.umsatzAnteile[i]) ||
    //     isEmpty(dtlData.abschriftenAnteilePct[i]) ||
    //     isEmpty(dtlData.kollVoorderPct[i]) ||
    //     isEmpty(dtlData.nosVororderPct[i]) ||
    //     isEmpty(dtlData.nosNachorderPct[i])
    //   ) {
    //     showToast("Please fill in all the input fields in the table.");
    //     return;
    //   }
    // }

    // ✅ Helper function to sum array
    const getTotal = (arr) =>
      arr.reduce((sum, val) => sum + (parseFloat(val) || 0), 0);

    // ✅ Calculate totals
    const totalUmsatz = getTotal(umsatzAnteile);
    const totalAbsch = getTotal(abschriftenAnteilePct);
    const totalKolPlan = getTotal(kollVoorderPct);
    const totalNosReorder = getTotal(nosNachorderPct);
    const totalNosVororder = getTotal(nosVororderPct);

    // 🚫 Block API if totals !== 100
    if (
      totalUmsatz != 100 ||
      totalAbsch != 100 ||
      totalKolPlan != 100 ||
      totalNosReorder != 100 ||
      totalNosVororder != 100
    ) {
      toast.dismiss();
      toast.error(
        <strong>❌ Each total must be exactly 100%. Please adjust the values.</strong>
      );
      return;
    }


    //  Prepare payload

    // console.log('dtl data from template new?', detailDiv)

    // return;


    const convertEmptyToZero = (obj) => {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [
          key,
          value === "" || value === null || value === undefined
            ? 0
            : value,
        ])
      );
    };



    const payload = {
      hdr: {
        ...convertEmptyToZero(hdrData),
        planYear: selectedYear,
        division: selectedHandler,
      },
      dtl: formattedDTLData,
      partP: [
        ...templateWesNewPart.koll.map((item) => ({
          ...convertEmptyToZero(item),
          soldTo: hdrData.soldTo,
          planYear: selectedYear,
          division: selectedHandler,
          typId: "KOLL",
        })),

        ...templateWesNewPart.Nos.map((item) => ({
          ...convertEmptyToZero(item),
          soldTo: hdrData.soldTo,
          planYear: selectedYear,
          division: selectedHandler,
          typId: "NOS",
        })),
      ],
    };

    // console.log('payload?', payload)

    // return;


    const apiCreate = `${process.env.REACT_APP_API_LINK}/api/v1/entry/saveTemplateData`;

    setUpdateLoading(true);

    try {
      let res;

      //  FINAL CONDITION (customerId + division + year)
      const isSameTemplate =
        Hdrvalu?.soldTo === soldTo &&
        Hdrvalu?.division === hdrData.division &&
        Hdrvalu?.planYear === hdrData.planYear;

      // OLD DATA (jo pehle se loaded hai)
      const oldPayload = {
        hdr: Hdrvalu,
        wes: {
          ...wesData,
          ...wes2Data,
        },
        dtl: dtlData,
      };

      //  Check payload changed or not
      const hasPayloadChanged = isPayloadChanged(oldPayload, payload);

      // Step-3

      //  CHECK IN REDUX ARRAY (customerId + division + year)
      const isTemplateExist = templateDetails?.some(
        (item) =>
          item.soldTo === hdrData.soldTo &&
          item.division === hdrData.division &&
          item.planYear === hdrData.planYear
      );
      if ((isSameTemplate && hasPayloadChanged && isTemplateExist) || (!isSameTemplate && !hasPayloadChanged && isTemplateExist) || (!isSameTemplate && hasPayloadChanged && isTemplateExist)) {

        //  CREATE
        res = await axios.post(apiCreate, payload, {
          headers: { Authorization: `Bearer ${authToken}` },
        });

      }
      // else if (isSameTemplate || hasPayloadChanged) {

      //   //  UPDATE
      //   res = await axios.put(apiUpdate, payload, {
      //     headers: { Authorization: `Bearer ${authToken}` },
      //   });

      // }
      else {

        // Default CREATE
        res = await axios.post(apiCreate, payload, {
          headers: { Authorization: `Bearer ${authToken}` },
        });

      }


      toast.success(`${soldTo} - ${res?.data?.message}`);
    } catch (error) {
      console.error("❌ Update API failed:", error);
      toast.error("Failed to update template");
    } finally {
      setUpdateLoading(false);
    }
  };

  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   return date.toLocaleString("en-IN", {
  //     day: "2-digit",
  //     month: "long",
  //     year: "numeric",
  //     hour: "numeric",
  //     minute: "2-digit",
  //     hour12: true,
  //     timeZone: "Asia/Kolkata",
  //   });
  // };

  const formatDate = (date) => {
    const d = new Date(date);

    const formattedDate = d.toLocaleDateString("en-GB");

    //  am to bin and pm to uhm in german
    const formattedTime = (() => {
      const h = d.getHours();
      const m = d.getMinutes();
      const hour12 = h % 12 || 12;
      const minutes = String(m).padStart(2, "0");
      const suffix = h < 12 ? "Bin" : "Uhr";
      return `${hour12}:${minutes} ${suffix}`;
    })();
    // console.log('formatted date?', formattedDate)
    // console.log('formatted time?', formattedTime)

    return `${formattedDate}   ${formattedTime}`;;
  };

  // useMemo is use hevay calculation
  const dates = [
    Hdrvalu?.updatedAt,
    WesValue?.updatedAt,
    DTLValue?.[0]?.updatedAt
  ]?.filter(Boolean);

  let latestDate = null;

  if (dates.length > 0) {
    latestDate = new Date(
      Math.max(...dates.map(d => new Date(d)))
    );
  }

  const formattedTime = latestDate ? formatDate(latestDate) : "";
  // console.log('formatted time?', formattedTime)


  useEffect(() => {
    // console.log('cleaned customer id?', cleanedCustomerID)
    if (cleanedCustomerID) {
      singleIdDataALL();
    }
  }, [cleanedCustomerID]);

  const singleIdDataALL = async () => {
    const soldTo = cleanedCustomerID;
    const div = division;
    const years = planYear;
    if (!soldTo) {
      return;
    }

    const api = `${process.env.REACT_APP_API_LINK}/api/v1/entry/getTemplateDataBySoldTo?soldTo=${soldTo}&division=${div}&year=${years}`;

    // console.log('api check?', api)
    try {
      const res = await axios.get(api, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      // console.log("get template response", res.data.data)
      setSingleApiData(res.data.data);
      // toast.success("Data revert successfully!")
    } catch (error) {
      console.error(" API Error:", error.message);
    }
  };

  return (
    <div className="main_template">
      <div className="inside_main_template">
        <div className="template_header">
          <Header />
          <div className="inside_template_header">
            <Row className=" row_template_dropDown">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "50%", }}>
                <Col lg={2} className="user_id_main_template ml-2">
                  <div className="user_id_main_template_text">
                    <Form.Label
                      htmlFor="username"
                      className="user_id_text m-0 p-0 ml-1"
                    >
                      Jahr
                    </Form.Label>
                  </div>
                  <div className="dropDown_jahr">
                    <select
                      name="jahrDropdown"
                      className="form-select dropDown_jahr "
                      value={selectedYear}
                      onChange={getFunction}
                    >
                      <option value="">Select Jahr</option>
                      {availableYears.map((item, index) => (
                        <option
                          value={item}
                          key={index}
                          className="dropDown_jahr"
                        >
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col lg={2} className="user_id_main_template">
                  <div className="user_id_main_template_text">
                    <Form.Label
                      htmlFor="username"
                      className="user_id_text m-0 p-0 ml-1"
                    >
                      Div
                    </Form.Label>
                  </div>
                  <div>
                    <select
                      className="form-select dropDown_jahr"
                      name="divDropdown"
                      value={selectedHandler}
                      onChange={getFunction}
                    >
                      <option value="">Select Div</option>
                      {availableHandler &&
                        availableHandler.map((item, index) => (
                          <option
                            value={item}
                            key={index}
                            className="dropDown_jahr"
                          >
                            {item}
                          </option>
                        ))}
                    </select>
                  </div>
                </Col>
              </div>
              <Col lg={4} className="user_id_main_template">
                <div className="user_id_main_template_text">
                  Die Vorgaben Limitplanung
                </div>
              </Col>

              {/*  */}
            </Row>
            <Row className="row_btn_main">

              <Col md={1} className="templetes_btn">
                <button
                  type="button"
                  className=" submitBtn btn btn-sm btn-secondary"
                  onClick={getBack}
                >
                  Beenden
                </button>
              </Col>
              <Col md={1} className="templetes_btn">
                <button
                  type="button"
                  className="submitBtn btn btn-sm btn-danger"
                  onClick={getReset}
                >
                  Zurücksetzen
                </button>
              </Col>

              {/* {!showSubmit ? ( */}
              {/* ) : ( */}
              <Col md={1} className="templetes_btn">
                <button
                  className="submitBtn2 btn btn-sm btn-primary"
                  onClick={() => handleUpdate(soldTo)}
                  disabled={updateLoading}
                >
                  {updateLoading ? (
                    <div id="loading_both">
                      <i id="spinner" className="fa fa-spinner fa-spin"></i>{" "}
                    </div>
                  ) : (
                    "Vorgabe aktualisieren/einreichen"
                  )}
                </button>
              </Col>
              {/* )} */}
              {/* {isCopy && ( */}
              {!resetFlag ?
                <Col md={1} className="templetes_btn">
                  <button
                    type="button"
                    className=" submitBtn btn btn-sm btn-danger"
                    onClick={handleDelete}
                    disabled={deleteLoading}
                  >
                    {deleteLoading ? (
                      <div id="loading_both">
                        <i id="spinner" className="fa fa-spinner fa-spin"></i>{" "}
                      </div>
                    ) : (
                      "Löschen"
                    )}
                  </button>
                </Col> : null}
              <Col md={1} className="templetes_btn">
                <button
                  onClick={getSubmitData}
                  className="submitBtn1 btn btn-sm btn-success"
                  disabled={sumbitLoading || resetText}
                  style={{
                    display: resetText || resetFlag ? "none" : "block",
                  }}
                >
                  {sumbitLoading ? (
                    <div id="loading_both">
                      <i id="spinner" className="fa fa-spinner fa-spin"></i>{" "}
                    </div>
                  ) : (
                    "Neu Vorgabe"
                  )}
                </button>
              </Col>
            </Row>
          </div>
        </div>

        <div className="template_container">
          {/* First Row - Equal Height */}
          <Row className="w-100 template_main_row">
            <Col md={4} >
              <div className="template-grid-box">
                <HdrTemplateNew
                  // KdNo={secondApiData}
                  KdNo={allUniqueSoldTos}
                  div={selectedHandler}
                  year={selectedYear}
                  wesData={wesData}
                  onDataChange={handleHdrDataChange}
                  singleData={SingleApiData}
                  resetFlag={resetFlag}
                  resetText={resetText}
                  templateWesNewPart={templateWesNewPart}
                  setTemplateWesNewPart={setTemplateWesNewPart}
                />
              </div>
            </Col>
            <Col md={8}>
              <div className="template-grid-box">
                <WesTemplateNew1
                  hdrValue={hdrData}
                  singleData={SingleApiData}
                  onDataChange={handleWesDataChange}
                  resetFlag={resetFlag}
                  templateWesNewPart={templateWesNewPart}
                  setTemplateWesNewPart={setTemplateWesNewPart}
                // WesNewValue={WesNewValue}
                />
              </div>
            </Col>
          </Row>

          {/* Second Row - Equal Height */}
          <Row className="w-100 template_main_row">
            <Col md={6} className="d-flex">
              <div className="template-grid-box">
                <DtlTemplateNew
                  hdrValue={hdrData}
                  onDataChange={handleDtlDataChange}
                  isRequired={true}
                  singleData={SingleApiData}
                  detailDiv={detailDiv}
                  setDetailDiv={setDetailDiv}
                />
              </div>
            </Col>
            <Col md={6} className="d-flex">
              <div className="template-grid-box">
                {/* <WesTemplateNew2
                  hdrValue={hdrData}
                  onDataChange={handleWes2DataChange}
                  singleData={SingleApiData}
                  resetFlag={resetFlag}
                  templateWesNewPart={templateWesNewPart}
                  setTemplateWesNewPart={setTemplateWesNewPart}
                /> */}
              </div>
            </Col>
          </Row>
        </div>

        <div className="last-update-div pb-2">
          <Row>
            {/* {(SingleApiData) && ( */}
            <Col md={12}>
              {formattedTime.length > 0 && (
                <div className="lastUpdate">
                  <div className="scroll-container">
                    <div className="scroll-text">
                      {`Zuletzt aktualisiert am ${formattedTime}`}
                    </div>
                  </div>
                </div>
              )}
            </Col>
            {/* )} */}
          </Row>
        </div>
      </div>

      <Footer className="footer" />
    </div>
  );
};

export default TemplatesNew;
